import React, { useState } from 'react';
import { Routes, Route, BrowserRouter } from "react-router-dom"


import "./App.css"
import Login from './components/Login';
import Navigation from './components/Navigation';
// import Layout from './components/Layout';



function App() {
  debugger
  const [isLoggedIn, setloggedin] = useState(
    Boolean(sessionStorage.getItem("loggedin"))
  );
  return (

    <div className="App">
      <BrowserRouter>
        {isLoggedIn
          ?
          <Navigation />
          :
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        }
      </BrowserRouter>

    </div>
  );
}

export default App;
